import { Grid } from '@progress/kendo-react-grid';
import { RefObject } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import { BlindReceivePermissions } from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';
import PoPercentage from 'src/sections/invoice_details/lineItemsColumns/PoPercent';
import TotalDocQuantityCell from 'src/sections/invoice_details/lineItemsColumns/TotalDocQuantityCell';

const useLineItemSummariesColumns: (tableRef: RefObject<Grid>) => GridColumn<any>[] = () => {
  const isBlindReceive = usePermission({ permissions: BlindReceivePermissions });

  const lineItemSummariesColumns: GridColumn<any>[] = [
    {
      field: 'completed',
      title: 'All Items Invoiced',
      width: '120px',
      dataType: 'fixed',
      menu: false,
    },
    ...(isBlindReceive
      ? []
      : ([
          {
            field: 'poQty',
            title: 'Total PO Qty',
            width: '120px',
            dataType: 'number',
            menu: false,
          },
        ] as GridColumn<any>[])),
    {
      field: 'previousQtys',
      title: 'Total Doc Qty',
      width: '120px',
      dataType: 'number',
      menu: false,
      component: TotalDocQuantityCell,
    },
    {
      field: 'invoicedPercent',
      title: '% Invoiced',
      width: '120px',
      format: '{0:n2}%',
      dataType: 'number',
      component: PoPercentage,
      menu: false,
    },
    {
      field: 'productItemNum',
      title: 'Item #',
      width: '120px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'description',
      title: 'Description',
      width: '150px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'uom',
      title: 'UOM',
      width: '100px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'priceAmt',
      title: 'Price',
      width: '100px',
      format: '{0:c}',
      dataType: 'dollar',
      menu: false,
    },
    {
      field: 'subTotal',
      title: 'Subtotal',
      width: '100px',
      format: '{0:c}',
      dataType: 'dollar',
      menu: false,
    },
  ];
  return lineItemSummariesColumns;
};

export default useLineItemSummariesColumns;
